import { defaultRowRenderer } from 'react-virtualized/dist/es/Table'

export const extendedTableRowRenderer = rowProps => {
  const { rowData } = rowProps
  if (rowData?.render) {
    return rowData.render?.(rowProps)
  }
  return defaultRowRenderer(rowProps)
}
